import React from "react"

function PartFourLanding() {
    return (
        <div className="phaseFourNormalWrapper">
            <h3 className="phaseIntro">When I returned home that evening there was an envelope waiting for me.  I struggled to make sense of what I found inside...</h3>

            <div className="envelope">
                <h1>LARRY MAXWELL</h1>
                <h3>Open When Alone</h3>
                <img id="envelopeKing" src={"./images/kingHead.png"} alt="the head of the King Of Diamonds"/>
                <div className="envelopeLipOutline"></div>
                <div className="envelopeLip"></div>
            </div>
        </div>
    )
}

export default PartFourLanding